import _ from 'underscore';

export const range = (start: number, end: number, step = 1) => {
  return _.range(start, end, step);
};
